import api from "../../services/api";
import {
  CREATE_ORDER_FAILURE,
  CREATE_ORDER_REQUEST,
  CREATE_ORDER_SUCCESS,
  ORDER_DETAIL_FAILURE,
  ORDER_DETAIL_REQUEST,
  ORDER_DETAIL_SUCCESS,
  RESET_ALL_ACTIONS,
  RESET_CREATE_ORDER,
  UPDATE_ORDER_PAYMENT_FAILURE,
  UPDATE_ORDER_PAYMENT_REQUEST,
  UPDATE_ORDER_PAYMENT_SUCCESS,
} from "./ActionType";

const createOrederRequest = () => {
  return {
    type: CREATE_ORDER_REQUEST,
  };
};

const createOrderSuccess = (order) => {
  return {
    type: CREATE_ORDER_SUCCESS,
    payload: order,
  };
};

const createOrderFailure = (error) => {
  return {
    type: CREATE_ORDER_FAILURE,
    payload: error,
  };
};

export const createOrder = (order) => async (dispatch) => {
  dispatch(createOrederRequest());
  try {
    const response = await api.post(`/orders`, order);

    dispatch(createOrderSuccess(response.data));
  } catch (error) {
    dispatch(createOrderFailure(error.response.data));
  }
};

export const resetCreateOrder = () => {
  return {
    type: RESET_CREATE_ORDER,
  };
};

const getOrderDetailRequest = () => {
  return {
    type: ORDER_DETAIL_REQUEST,
  };
};

const getOrderDetailSuccess = (order) => {
  return {
    type: ORDER_DETAIL_SUCCESS,
    payload: order,
  };
};

const getOrderDetailFailure = (error) => {
  return {
    type: ORDER_DETAIL_FAILURE,
    payload: error,
  };
};

export const getOrderDetail = (orderId) => async (dispatch) => {
  dispatch(getOrderDetailRequest());
  try {
    const response = await api.get(`/orders/${orderId}`);
    dispatch(getOrderDetailSuccess(response.data));
  } catch (error) {
    dispatch(getOrderDetailFailure(error.response.data));
  }
};

const updateOrderPaymentRequest = () => {
  return {
    type: UPDATE_ORDER_PAYMENT_REQUEST,
  };
};

const updateOrderPaymentSuccess = (order) => {
  return {
    type: UPDATE_ORDER_PAYMENT_SUCCESS,
    payload: order,
  };
};

const updateOrderPaymentFailure = (error) => {
  return {
    type: UPDATE_ORDER_PAYMENT_FAILURE,
    payload: error,
  };
};

export const updateOrderPayment =
  (orderId, paymentDetails) => async (dispatch) => {
    dispatch(updateOrderPaymentRequest());
    try {
      const response = await api.put(
        `/orders/${orderId}/payment`,
        paymentDetails
      );
      dispatch(updateOrderPaymentSuccess(response.data));
    } catch (error) {
      dispatch(updateOrderPaymentFailure(error.response.data));
    }
  };

export const resetAllActions = () => {
  return {
    type: RESET_ALL_ACTIONS,
  };
};
